import React from 'react'
import { CircularProgress, Box, Typography } from '@material-ui/core'

const Wrapper = ({ inProgress, children }) => {
  return inProgress ? (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        mt: '20px',
        gap: '1rem'
      }}>
      <CircularProgress />
      <Typography>Loading...</Typography>
    </Box>
  ) : (
    children
  )
}

export default Wrapper
